var map = {
	"./banner-shape.png": 405,
	"./boarding.png": 273,
	"./day-care.png": 818,
	"./dog-base.jpeg": 609,
	"./furry-fort-icon.png": 970,
	"./pet-clinic.png": 265,
	"./pet-spa.png": 45,
	"./svgs": 121,
	"./svgs/": 121,
	"./svgs/index": 121,
	"./svgs/index.js": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;